import { createStore } from 'satcheljs';
import { FeedbackManagerStore } from './schema/FeedbackManagerState';

let locationFeedbackManagerStore: FeedbackManagerStore = {
    feedbackManagerState: undefined,
};

let LocationFeedbackManagerStore = createStore<FeedbackManagerStore>(
    'locationFeedbackManagerStore',
    locationFeedbackManagerStore
)();
export default LocationFeedbackManagerStore;
